import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { BaseHttpService } from './base-http.service';
import { AccessCard } from '../models';


@Injectable()
export class AccessCardService extends BaseHttpService<AccessCard> {

  constructor() {
    super('access-card');
  }

  getByUserId(userId: number): Observable<AccessCard[]> {
    return this.httpClient
      .get(this.uri + `/GetByUserId?userId=${userId}`)
      .catch(this.handleError);
  }



}



// WEBPACK FOOTER //
// ./src/app/core/data/access-card.service.ts